module.exports = new __parcel__URL__("../treeCreation.d0b17783.png").toString();